const capitalizeFirstLetter = (event, setFieldValue, value = '') => {
    setFieldValue(
        event?.target?.name,
        event?.target?.value?.length === 1 && value === ''
            ? event?.target?.value.toUpperCase() 
            : event?.target?.value
    );
}

export default capitalizeFirstLetter;